import React, { useState } from 'react';
import { REPORTS } from '../../constants/columns';
import { useTable, useGlobalFilter, usePagination } from 'react-table';
import { reportOptions } from '../../constants/filterOptions';
import { useNavigate } from 'react-router-dom';

// components
import Header from '../../components/Header/Header';
import Table from '../../components/Table/Table';
import TableTabs from '../../components/TableTabs/TableTabs';
import Empty from '../../components/Empty/Empty';

// icons
import icon from '../../brand/generated/sidebar/report.svg';
import ReportCreate from './NewReport/ReportCreate';
import AppReportRefresh from './AppReportRefresh/AppReportRefresh';

const columns = REPORTS;
const tableStyle = { backgroundColor: 'white' };

const Cars = () => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const table = useTable(
    {
      columns,
      data: reports,
    },
    useGlobalFilter,
    usePagination
  );
  const { setGlobalFilter, page } = table;

  const [value, setValue] = useState('');
  const [values, setValues] = useState({
    fio: '',
    iin: '',
    vip: '',
    company: '',
    role: '',
    phone: '',
    email: '',
    broker: '',
  });

  const addReport = () => {
    navigate('/reports/create');
  };

  return (
    <>
      <ReportCreate />
      <AppReportRefresh />
    </>
  );

  return (
    <>
      <Header title="Мои отчеты" icon={icon} />
      <br />
      <br />
      <br />
      <br />
      <TableTabs
        setFilter={setGlobalFilter}
        options={reportOptions}
        value={value}
        setValue={setValue}
        values={values}
        setValues={setValues}
        navigate={addReport}
        button={'Сформировать новый отчет'}
        inputPlaceholder={'Быстрый поиск по отчетам'}
      />
      <br />
      {!page.length ? (
        <Empty />
      ) : (
        <Table table={table} style={tableStyle} pagination setPagination={setPagination} p={pagination} />
      )}
    </>
  );
};

export default Cars;
